// src/pages/Iletisim.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import DOMPurify from "dompurify";
import Layout from "components/yenimahalle/Layout";
import ContentHeader from "components/yenimahalle/ContentHeader";
import Map from "components/yenimahalle/Map";
import PortalApi from "../../api/PortalApi";
import IletisimDetay from "components/yenimahalle/IletisimDetay";

// wrapper for content area
const Container = styled.div.attrs({ className: "container mt-5" })``;
const CardContainer = styled.div.attrs({ className: "card" })``;
const CardBody = styled.div.attrs({ className: "card-body" })`
  overflow-x: auto;
  & table { width: 100%; table-layout: fixed; }
    .title { ${tw`mb-5 text-base font-semibold text-3xl text-center`} }
  
  & table th, & table td { white-space: normal; word-wrap: break-word; word-break: break-word; }
`;

function sanitizeHtml(html = "") {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["table", "thead", "tbody", "tr", "th", "td", "br", "strong", "p", "a", "div", "span"],
    ALLOWED_ATTR: ["href", "target", "rel", "colspan", "rowspan", "style"],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|ftp):|mailto:|tel:|\/\/)/i,
  });
  return clean;
}

const Iletisim: React.FC = () => {
  const [tableHtml, setTableHtml] = useState<string | null>(null);

  useEffect(() => {
    PortalApi.getContent(20).then((resp) => {
      const cells = resp.contentLinesList.flatMap(line => line.contentCellList);
      const tables = cells
        .filter(cell => cell.contentType === 2 && /<table[\s\S]*?>/.test(cell.content || ""))
        .map(cell => cell.content || "");
      setTableHtml(tables.length ? tables.join('') : null);
    });
  }, []);

  return (
    <Layout>
      <ContentHeader headingLine2="İletişim" />
      <IletisimDetay />
      <Map />
      <Container>

        <CardContainer>
          <CardBody>
            <div className="title">Müdürlük İletişim Bilgileri</div>
            {tableHtml ? (
              <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(tableHtml) }} />
            ) : (
              <p>Tablo bulunamadı.</p>
            )}
          </CardBody>
        </CardContainer>
      </Container>

    </Layout>
  );
};

export default Iletisim;
